import { ICompletedIntakes } from '@folx-types/member';
import { equals, find, map, or } from 'ramda';

type GetCompletedHrtIntakes = (intakeData?: ICompletedIntakes & unknown) => string;
export const getCompletedHrtIntakes: GetCompletedHrtIntakes = (intakeData) => {
	const completedIntakes = map((i) => i.kind, intakeData?.intakes ?? []);
	const hrtIntakes =
		find((intake) => or(equals(intake, 'HRT_T'), equals(intake, 'HRT_E')), completedIntakes) ?? '';
	return hrtIntakes;
};
